function isNullOrWhiteSpace (value) {
  if (!value) {
    return true
  }
  if (/^\s*$/.test(value)) {
    return true
  }
  return false
}

function isEmail (value) {
  if (isNullOrWhiteSpace(value)) {
    return false
  }
  if (/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
    return true
  }
  return false
}

function isPassword (value) {
  if (isNullOrWhiteSpace(value)) {
    return false
  }
  if (value.length < 6) {
    return false
  }
  return true
}

export {
  isNullOrWhiteSpace,
  isEmail,
  isPassword
}
